import React from 'react';
import './pop-up.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faExclamationTriangle  } from '@fortawesome/free-solid-svg-icons';

function PopUp({show, setShow, message, action, status}) {
    let icon = {
      icon: '',
      color: '',
    };

    if(status === 'success')  icon = { icon: faCheck, color: "#56F000" };
    if(status === 'error')  icon = { icon: faTimes, color: "#FF3838" };
    if(status === 'warning')  icon = { icon: faExclamationTriangle, color: "#FFB302" };
    console.log('status', status)
  return (
    <>
    <div className={`popUp d-flex flex-column justify-content-center align-items-center ${status}`}>
        <div
          className="icon-container"
          style={{
            border: `4px solid ${icon.color}`
          }}
        >
            <FontAwesomeIcon icon={icon.icon} style={{ fontSize: "2rem", color: icon.color }} />
        </div>
        <h4 className='mb-0'>{action}</h4>
        {/* {
          message && (
            <p> {message} </p>
          )
        } */}
        
        <button className={`${status} close text-white `} style={{fontSize: '.9rem', width: 200}} onClick={() => setShow(false)}>
            Aceptar
        </button> 
    </div>
    </>
  )
}

export default PopUp